type ReturnType = {
    [key: string]: string;
};

const parseQuery = (queryString: string = ''): ReturnType => {
    if (!queryString) return {};

    var query: ReturnType = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
};

export default parseQuery;
